// extracted by mini-css-extract-plugin
export default {"modalParticipateContainer":"modalParticipateContainer__2ML6y","text":"text__qgUct","button":"button__kp83S"};